/*
 * auth (utils)
 */
import { supabase } from "@psychology/auth/client"
import { toast } from "@psychology/react-ui"
import { AppPlatform, isDebug } from "@psychology/utils"
import { redirect } from "@tanstack/react-router"

type AuthPageLoaderOptions = {
	allowUnauthenticated?: boolean
	allowUnauthorized?: boolean
	redirectAuthorized?: string
}

export const authPageLoaderSoft =
	({
		allowUnauthenticated,
		allowUnauthorized,
		redirectAuthorized,
	}: AuthPageLoaderOptions) =>
	async () => {
		const { data, error } = await supabase.auth.getSession()
		if (error) {
			console.error("Auth getSession Error", { error })
		}

		let authenticated = true
		let authorized = true

		if (!data.session) {
			if (!allowUnauthenticated) {
				throw redirect({ to: "/auth" })
			}
			authenticated = false
		} else if (!data.session.user.user_metadata[AppPlatform]) {
			if (!allowUnauthorized) {
				throw redirect({ to: "/waitlist" })
			}
			authorized = false
		} else if (redirectAuthorized) {
			throw redirect({ to: redirectAuthorized })
		}

		if (isDebug) {
			console.log("User", data.session?.user)
		}

		return {
			authenticated,
			authorized,
			user: data.session?.user,
			token: data.session?.access_token,
		}
	}

export async function authPageLoader() {
	const { data, error } = await supabase.auth.getSession()
	if (error) {
		console.error("Auth getSession Error", { error })
	}

	if (!data.session) {
		throw redirect({ to: "/auth" })
	} else if (!data.session.user.user_metadata[AppPlatform]) {
		throw redirect({ to: "/waitlist" })
	}

	if (isDebug) {
		console.log("User", data.session.user)
	}

	return {
		user: data.session.user,
		token: data.session.access_token,
	}
}

export async function adminPageLoader() {
	const { data, error } = await supabase.auth.getSession()
	if (error) {
		console.error("Auth getSession Error", { error })
	}

	if (!data.session) {
		throw redirect({ to: "/auth" })
	} else if (!data.session.user.user_metadata[AppPlatform]) {
		throw redirect({ to: "/waitlist" })
	} else if (!data.session.user.user_metadata[AppPlatform]?.isAdmin) {
		toast("Unauthorized")
		throw redirect({ to: "/dashboard" })
	}

	if (isDebug) {
		console.log("User", data.session.user)
	}

	return {
		user: data.session.user,
		token: data.session.access_token,
	}
}

export const authPageLoaderAuthenticated =
	(redirectAuthorized?: string) => async () => {
		const { data, error } = await supabase.auth.getSession()
		if (error) {
			console.error("Auth getSession Error", { error })
		}

		if (!data.session) {
			throw redirect({ to: "/auth" })
		} else if (data.session.user.user_metadata[AppPlatform]) {
			if (redirectAuthorized) {
				throw redirect({ to: redirectAuthorized })
			}
		}

		if (isDebug) {
			console.log("User", data.session.user)
		}

		return {
			user: data.session.user,
			token: data.session.access_token,
		}
	}
